import * as yup from 'yup';


const addProjectSchema = yup.object({
  title: yup.string('Project title').required('Project title required'),
  description: yup.string('Description')
  // .min(300, 'Description should be of minimum 300 characters length')
  // .max(500, 'Description should be of maximum 500 characters length')
  .required('Description required'),
  type: yup.string('Project Type ').required('Project Type is required'),
  startDate: yup.date('Production start date').required('Production start date is required'),
  endDate: yup.date('Production end date').required('Production end date is required'),
  // genre:   yup.array().required("Genre is Required"),
  language: yup.string('Genre').required('Genre is required'),
  location: yup.string('Production location').required('Production location is required'),
  synopsis: yup.string('Synopsis')
  // .min(300, 'Synopsis should be of minimum 300 characters length')
  // .max(500, 'Synopsis should be of maximum 500 characters length')
  ,
  role: yup.string('role'),
  website: yup.string('Website').url(),
  imdb: yup.string('IMDB').matches(/imdb.com/, "Please enter valid IMDb url").url("The link must be a valid url"),
  vimeo: yup.string('Vimeo').matches(/vimeo.com/, "Please enter valid vimeo url").url("The link must be a valid url"),
  facebook: yup.string('Facebook').matches(/facebook.com/, "Please enter valid facebook url").url("The link must be a valid url"),
  instagram: yup.string('Instagram').matches(/instagram.com/, "Please enter valid instagram url").url("The link must be a valid url"),
});


const initialValues = {
  title: '',
  description: '',
  type: '',
  startDate: '',
  endDate: '',
  language: '',
  location: '',
  synopsis: '',
  website: '',
  imdb:'',
  vimeo: '',
  facebook: '',
  instagram: '',
  role: '',
}


const AddProjectValidation = {initialValues, addProjectSchema}
export default AddProjectValidation;